import React, { FC } from "react";
import { Route, Switch } from "react-router-dom";
import { LoginPage } from "src/common/LoginPage";
import NeurapulsePage from "src/neurapulse/neurapulsePage";

const PublicRoutes: FC = () => {
	return (
		<Switch>
			<Route path="/" exact component={LoginPage} />
			<Route path="/neurapulse" component={NeurapulsePage} />
		</Switch>
	);
};

export default PublicRoutes;
